module.exports = __webpack_public_path__ + "static/media/A13.4a7a2012.jpg";